const LessThanIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <path d="m18.5 4.14 1 1.72L8.97 12l10.53 6.14-1 1.72L5 12l13.5-7.86Z" />
  </svg>
)
export default LessThanIcon
